import { lazy } from 'react';

export const EditObjectPage = lazy(() =>
  import('./ui/EditObjectPage').then((module) => ({
    default: module.EditObjectPage,
  }))
);
